
import { useState } from "react";
import { usePhoneScreening } from "./screening/usePhoneScreening";
import { useDeepInterview } from "./screening/useDeepInterview";
import { useFraudDetection } from "./screening/useFraudDetection";

export const useScreeningAgent = () => {
  const [isLoading, setState] = useState(false);
  const { phoneScreening, conductLivePhoneScreen } = usePhoneScreening();
  const { deepInterview, deepRoleInterview } = useDeepInterview();
  const { fraudDetection, runFraudDetection } = useFraudDetection();

  return {
    isLoading,
    phoneScreening,
    deepInterview,
    fraudDetection,
    conductLivePhoneScreen,
    deepRoleInterview,
    runFraudDetection
  };
};
